import { API } from '../Api';

// Ví token AI (Task #6). auid gateway tự inject từ JWT — FE không cần gửi.

export interface AiPackage {
  code: string;
  tokens: number;
  priceCa: number;
  originalPriceCa?: number;
  clanDiscountPercent?: number;
}

export interface AiStatus {
  model: string;
  imageEnabled: boolean;
  freePerDay: number;
  freeRemaining: number;
  monthlyQuota: number;
  monthlyRemaining: number;
  tokenBalance: number;
  totalAvailable: number;
  canAsk: boolean;
  packages: AiPackage[];
}

export interface ConsumeAiResult {
  isSuccess: boolean;
  message?: string | null;
  unitsCharged: number;
  source: string;
  totalAvailable: number;
}

export interface PurchaseAiResult {
  isSuccess: boolean;
  message?: string | null;
  tokenBalance: number;
  caBalanceAfter: number;
}

export interface AskAiResult {
  reply: string;
  blocked: boolean;
  outOfTokens: boolean;
  unitsCharged: number;
  totalAvailable: number;
  isMock: boolean;
}

const BASE = '/v1/payment-service/ai';
const CHAT_BASE = '/v1/post-service/ai-chat';

export const getAiStatus = () => API.get<AiStatus>(`${BASE}/status`).then((r) => r.data);

// Hỏi trợ lý AI (5 lớp an toàn + trừ token ở BE). Đang chạy mock cho tới khi có OpenAI key.
export const askAssistant = (question: string) =>
  API.post<AskAiResult>(`${CHAT_BASE}/ask`, { question }).then((r) => r.data);

export const purchaseAiPackage = (code: string) =>
  API.post<PurchaseAiResult>(`${BASE}/purchase-package`, { code }).then((r) => r.data);

// Dùng ở Phase 3 (sau khi có usage thật từ LLM) — trừ token.
export const consumeAiTokens = (realTokensIn: number, realTokensOut: number, kind = 'chat') =>
  API.post<ConsumeAiResult>(`${BASE}/consume`, { realTokensIn, realTokensOut, kind }).then((r) => r.data);
